import ProductOverviewCard from './ProductOverviewCard'
import EmptyState from '../../components/ui/EmptyState'

function ProductOverviewGrid({ products, onAdd }) {
  if (!products || products.length === 0) {
    return (
      <EmptyState
        icon="🚀"
        title="No products yet"
        description="Add your first product to start tracking the studio"
        action={onAdd}
        actionLabel="Add Product"
      />
    )
  }

  return (
    <div className="grid grid-3">
      {products.map(product => (
        <ProductOverviewCard key={product.id} product={product} />
      ))}
    </div>
  )
}

export default ProductOverviewGrid
